import { Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Ws from '../../providers/Ws';
import BilanturiRow from './BilanturiRow';
import FinalizeazaBilant from './FinalizeazaBilant';
import UtilsFinanciar from './UtilsFinanciar';


export default class BilantRows extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            bilant: {},
            bilantRows: [],
            idx: 0,
            totalRows: 0,
            finalizeaza: false,
            alertView:false
        }
    }

    componentDidMount() {
        this.access()
        this.getData()
    }

    ws = new Ws()
    uF = new UtilsFinanciar()
    ls = new LocalStorage().GetUserData()




    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.AccessFinanciar === 1 ? false : true })
        }


    }



    getData = async () => {

        let getBilant = await this.ws.customSelect('select * from fin_import_bilant_head where id = @p1', {
            p1: this.props.match.params.idBilant
        })


        if (getBilant.Succes) {

            let bilant = { ...getBilant.Content[0] }

            let bilantRows = []

            if (bilant.tip === 'Micro') {

                if (Number(bilant.an) <= 2018) {

                    bilantRows = this.uF.bilantMicroStruct_2016
                } else if (Number(bilant.an) > 2018) {
                    bilantRows = this.uF.bilantMicroStruct_2020
                }

            } else if (bilant.tip === 'Macro') {
                if (Number(bilant.an) <= 2016) {

                    bilantRows = this.uF.bilantMicroStruct_2016
                } else if (Number(bilant.an) > 2018) {
                    bilantRows = this.uF.bilantMicroStruct_2020
                }

            } else {
                if (Number(bilant.an) <= 2016) {

                    bilantRows = this.uF.bilantMicroStruct_2016
                } else if (Number(bilant.an) > 2018) {
                    bilantRows = this.uF.bilantMicroStruct_2020
                }

            }

            console.log('bilant :>> ', bilant);
            console.log('bilantRows :>> ', bilantRows);

            this.setState({
                bilant: bilant,
                bilantRows: bilantRows,
                totalRows: bilantRows.length
            })
        }


    }

    goToFinalizeaza = () => {

        console.log('goToFinalizeaza :>> ',);

        this.setState({
            finalizeaza: true,
            bilantRows: []
        })
    }


    goBackToBilant = () => {
        this.props.history.push(`/datedesprebilant/${this.props.match.params.idBilant}`)

    }





    render() {
        return (
            <div>

                <CustomAppBar history={this.props.history} title='' />
                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />



                <Grid style={{ maxWidth: 1200, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                        {/* todo denumire bilant */}
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>Bilant anual {this.state.bilant.an}</h1>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                            {this.state.bilantRows.length > 0 &&

                                <BilanturiRow
                                    idHead={this.props.match.params.idBilant}
                                    bilanturiRows={this.state.bilantRows}
                                    goToFinalizeaza={this.goToFinalizeaza}
                                    goBackToBilant={this.goBackToBilant}

                                />

                            }


                            {this.state.finalizeaza &&

                                <FinalizeazaBilant
                                    dictionary={this.dictionary}
                                    bilant={this.state.bilant}
                                    history={this.props.history}
                                />

                            }

                        </Grid>
                    </Grid>
                </Grid>

            </div >
        );
    }
}